// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.bs.mjs";
import * as Core__Array from "@rescript/core/lib/es6/src/Core__Array.bs.mjs";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.bs.mjs";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";
import * as ExternalAPI$LumiCentral from "lumi-central/lib/es6/src/ExternalAPI.bs.mjs";

var defaultStaticRefreshInterval = [
  3600000,
  3600000
];

var defaultDynamicRefreshInterval = [
  60000,
  900000
];

function useInfos(organisation, minMaxRefreshIntervalOpt, param) {
  var minMaxRefreshInterval = minMaxRefreshIntervalOpt !== undefined ? minMaxRefreshIntervalOpt : defaultStaticRefreshInterval;
  var match = React.useState(function () {
        
      });
  var setInfos = match[1];
  LumiReact.usePeriodic(minMaxRefreshInterval[0], minMaxRefreshInterval[1], (function (next) {
          return LumiRequest.resultFutureEffect(ExternalAPI$LumiCentral.V3.getFacilityInfo(organisation), (function (infos) {
                        setInfos(function (param) {
                              return infos;
                            });
                        next(true);
                      }), (function (err) {
                        console.error("Error loading facility info", err);
                        next(false);
                      }));
        }), [organisation]);
  return match[0];
}

function useParkingCounts(organisation, minMaxRefreshIntervalOpt, param) {
  var minMaxRefreshInterval = minMaxRefreshIntervalOpt !== undefined ? minMaxRefreshIntervalOpt : defaultDynamicRefreshInterval;
  var match = React.useState(function () {
        
      });
  var setParkingCounts = match[1];
  LumiReact.usePeriodic(minMaxRefreshInterval[0], minMaxRefreshInterval[1], (function (next) {
          return LumiRequest.resultFutureEffect(ExternalAPI$LumiCentral.V3.getParkingCount(organisation), (function (parkingCounts) {
                        setParkingCounts(function (param) {
                              return parkingCounts;
                            });
                        next(true);
                      }), (function (err) {
                        console.error("Error loading parking counts", err);
                        next(false);
                      }));
        }), [organisation]);
  return match[0];
}

function zipInfosWithParkingCounts(infos, parkingCounts, upperSuffix, lowerSuffix, param) {
  var hasSuffix = function (str, suffix) {
    if (suffix !== undefined) {
      return str.endsWith(suffix);
    } else {
      return false;
    }
  };
  return Core__Array.filterMap(infos, (function (info) {
                if (hasSuffix(info.name, upperSuffix) || hasSuffix(info.name, lowerSuffix)) {
                  return ;
                } else {
                  return Core__Option.map(parkingCounts.find(function (pc) {
                                  return pc.id === info.id;
                                }), (function (total) {
                                return {
                                        info: info,
                                        total: total,
                                        upper: Core__Option.flatMap(upperSuffix, (function (suffix) {
                                                return parkingCounts.find(function (pc) {
                                                            return pc.facilityName === info.name + suffix;
                                                          });
                                              })),
                                        lower: Core__Option.flatMap(lowerSuffix, (function (suffix) {
                                                return parkingCounts.find(function (pc) {
                                                            return pc.facilityName === info.name + suffix;
                                                          });
                                              }))
                                      };
                              }));
                }
              }));
}

function useZippedParkingCounts(organisation, upperSuffix, lowerSuffix, staticRefreshIntervalOpt, dynamicRefreshIntervalOpt, param) {
  var staticRefreshInterval = staticRefreshIntervalOpt !== undefined ? staticRefreshIntervalOpt : defaultStaticRefreshInterval;
  var dynamicRefreshInterval = dynamicRefreshIntervalOpt !== undefined ? dynamicRefreshIntervalOpt : defaultDynamicRefreshInterval;
  var infos = useInfos(organisation, staticRefreshInterval, undefined);
  var parkingCounts = useParkingCounts(organisation, dynamicRefreshInterval, undefined);
  if (infos !== undefined && parkingCounts !== undefined) {
    return zipInfosWithParkingCounts(infos, parkingCounts, upperSuffix, lowerSuffix, undefined);
  }
  
}

var T;

export {
  T ,
  defaultStaticRefreshInterval ,
  defaultDynamicRefreshInterval ,
  useInfos ,
  useParkingCounts ,
  zipInfosWithParkingCounts ,
  useZippedParkingCounts ,
}
/* react Not a pure module */
